import { AnomalyChecker } from './anomaly-checker.interface';
import { MonitoringFailureReason } from '../monitoring-anomaly.model';
import { MonitoringSystemDetail } from '../monitoring-detection.service';

/**
 * Anomaly checker for Smartlook
 */
export class SmartlookAnomalyChecker implements AnomalyChecker {
  readonly key = 'smartlook';
  readonly name = 'Smartlook';

  check(): MonitoringSystemDetail {
    const result: MonitoringSystemDetail = {
      isActive: false,
      scriptLoaded: false,
      lastChecked: Date.now(),
    };

    try {
      if (typeof window === 'undefined') {
        result.failureReason = MonitoringFailureReason.UNKNOWN;
        return result;
      }

      // Check if script tag exists
      const scriptTag = document.querySelector(
        'script[src*="smartlook.cloud"]',
      );
      result.scriptLoaded = scriptTag !== null;

      const smartlook = (window as any).smartlook;
      const smartlookIntegrated = (window as any).smartlookIntegrated;

      // Check if smartlook object exists and has required methods
      if (smartlook && smartlookIntegrated === true) {
        // Verify smartlook has the expected API
        if (
          typeof smartlook.init === 'function' ||
          smartlook._debugData !== undefined
        ) {
          result.isActive = true;
          return result;
        }

        result.failureReason = MonitoringFailureReason.NOT_INITIALIZED;
        return result;
      }

      // Determine failure reason
      if (!result.scriptLoaded) {
        result.failureReason = MonitoringFailureReason.NOT_LOADED;
      } else {
        result.failureReason = MonitoringFailureReason.BLOCKED;
      }

      return result;
    } catch (error) {
      console.error(
        `[MonitoringDetection] Error checking ${this.name}:`,
        error,
      );
      result.failureReason = MonitoringFailureReason.UNKNOWN;
      return result;
    }
  }
}
